const collection = {
    slug: "comme-des-garcons-homme-plus-2023ss-another-kind-of-punk-guide",
    metaTitle:
      "コムデギャルソンオムプリュス 2023SSとは｜ANOTHER KIND OF PUNKとレンタル・買取ガイド",
    metaDescription:
      "COMME des GARÇONS HOMME PLUS 2023SS『ANOTHER KIND OF PUNK』を解説。川久保玲が中世の宮廷道化師に見たパンク精神、ジョーカー、権威への批評、強い色彩、左右非対称の配色、膨らんだパンツを読み解きます。Enclopediaでレンタルできるコムデギャルソンオムプリュスのアーカイブと買取相談まで案内します。",
    metaKeywords:
      "コムデギャルソンオムプリュス 2023SS,COMME des GARCONS HOMME PLUS 2023SS,ANOTHER KIND OF PUNK,コムデギャルソンオムプリュス ANOTHER KIND OF PUNK,コムデギャルソンオムプリュス レンタル,COMME des GARCONS HOMME PLUS レンタル,コムデギャルソンオムプリュス 買取,COMME des GARCONS HOMME PLUS 買取,コムデギャルソンオムプリュス 名作,コムデギャルソンオムプリュス アーカイブ,コムデギャルソン パンク,コムデギャルソン 道化師,コムデギャルソン ジョーカー,川久保玲 パンク,コムデギャルソン 買取,COMME des GARCONS 買取,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/comme-des-garcons-homme-plus-2023ss-another-kind-of-punk-guide",
    heroImage:
      "media/archive_fashion/archive14.png",
    heroImageAlt:
      "COMME des GARÇONS HOMME PLUS 2023SS ANOTHER KIND OF PUNK 宮廷道化師とパンク精神を解説するEnclopediaアーカイブガイド画像",
    heroNumber: "14 / ANOTHER KIND OF PUNK",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "COMME des GARÇONS HOMME PLUS 2023SS『ANOTHER KIND OF PUNK』",
    lead:
      "COMME des GARÇONS HOMME PLUS 2023SS『ANOTHER KIND OF PUNK』。\n\n川久保玲が見たのは、トランプのジョーカーの原型にもつながる中世の宮廷道化師でした。\n道化師は、ただ人を笑わせる存在ではありません。\n権力のすぐそばにいながら、普通なら言えないことを言う。\n冗談や奇妙さを使って、真面目な批評では届かないものを差し込む。\n\nこのシーズンの服にも、その感覚が濃く表れています。\n強い色、左右で切り替えられた配色、膨らんだパンツ、どこか滑稽で、少し不穏なシルエット。\nふざけているように見えるのに、ただ軽くはない。\n\nクラシックな服の中に、道化師の滑稽さと知性が入り込んでいる。\nEnclopediaでは、このシーズンを“見て終わるコレクション”ではなく、実際に着て体験できるHOMME PLUSの入口として読み解きます。",
    keywordLine: [
      "another kind of punk",
      "court jester",
      "homme plus rental",
      "archive buyback",
    ],
    thesis:
      "2023SS『ANOTHER KIND OF PUNK』の重要性は、パンクを破れた服や鋲の記号ではなく、権威に対する態度として捉え直した点にあります。",
    whyTitle:
      "なぜ宮廷道化師が、“もう一つのパンク”になるのか。",
    whyBody:
      "一般的にパンクと聞くと、破れた服、鋲、レザー、反抗的な音楽、制度の外側から叫ぶ態度を連想します。\nしかしCOMME des GARÇONS HOMME PLUS 2023SSが描いたパンクは、そうした見た目の記号だけではありません。\n\n川久保玲が注目したのは、中世の宮廷道化師です。\n道化師は、権力の外側にいる存在ではありません。\nむしろ権力のすぐそばにいて、王や主君に普通なら言えないことを言う存在でした。\n笑い、奇妙さ、滑稽さを使いながら、制度の内側に批評を差し込む。\n\nこの構造は、非常にパンクです。\n制度の外から破壊するのではなく、制度の中に入り込み、その内側で違和感として残り続ける。\n\n2023SSのHOMME PLUSに現れる強い色、左右非対称の配色、膨らんだパンツ、クラシックな服の中に混じる滑稽さは、その態度を服に変換したものです。\nEnclopediaでは、この文脈を入口に、HOMME PLUSのアーカイブを実際に着る体験、そして所有している一着の買取相談へつなげます。",
    pillars: [
      {
        number: "01",
        title: "JESTER AS CRITIC",
        text:
          "宮廷道化師は、ただの笑わせ役ではありません。権力の近くにいながら、奇妙さと冗談によって真実を差し込む存在です。",
      },
      {
        number: "02",
        title: "PUNK AS ATTITUDE",
        text:
          "このシーズンのパンクは、破れた服や鋲の記号ではありません。権威に対する距離の取り方、制度の中で違和感として残る態度です。",
      },
      {
        number: "03",
        title: "RENTAL AS EXPERIENCE",
        text:
          "COMME des GARCONS HOMME PLUSのシーズン性は、写真だけでは伝わりきりません。色、パンツの膨らみ、身体の見え方は、実際に着ることで理解が深まります。",
      },
    ],
    readingTitle:
      "宮廷道化師、ジョーカー、色彩、パンクから読む『ANOTHER KIND OF PUNK』。",
    readingIntro:
      "このコレクションは、派手な色や道化師風の見た目だけで成立しているわけではありません。なぜ道化師なのか、なぜそれがパンクなのか、なぜ滑稽さが批評性へ変わるのかを見ることで、川久保玲のHOMME PLUSらしい読み替えが見えてきます。",
    observations: [
      {
        index: "01",
        title:
          "道化師は、笑わせる人ではなく、権力のそばにいる批評者だった",
        text:
          "道化師という存在は、一見すると軽く見えます。\n派手な服、奇妙な帽子、滑稽な動き、冗談。\nしかし宮廷道化師は、ただ人を笑わせるだけの存在ではありませんでした。\n\n王や主君の近くにいながら、普通なら言えないことを言う。\nふざけた形式を借りることで、真面目な言葉では届かない批評を差し込む。\n\nHOMME PLUS 2023SSが道化師を扱う意味はここにあります。\n見た目は滑稽でも、その内側には知性と危うさがある。\nこれが『ANOTHER KIND OF PUNK』の出発点です。",
      },
      {
        index: "02",
        title:
          "パンクは、制度の外から叫ぶことだけではない",
        text:
          "パンクはしばしば、破れた服、鋲、レザー、ノイズ、反抗の記号として理解されます。\nしかし川久保玲がここで示したのは、別のパンクです。\n\n制度の外側に出るのではなく、制度の中に入り込む。\nその中で、場違いな色、奇妙な形、滑稽な身振りとして残り続ける。\n\n宮廷道化師は、王宮という制度の内側にいながら、権威を揺さぶる存在でした。\nだからこそ、このシーズンのパンクは見た目の反抗ではなく、権威に対する態度として成立しています。",
      },
      {
        index: "03",
        title:
          "強い色彩は、滑稽さと不穏さを同時に作る",
        text:
          "このシーズンでは、強い色の切り替えや左右非対称の配色が印象的です。\n色は明るく、時にポップにも見えます。\nしかし全体としては、ただ楽しいだけではありません。\n\n道化師の服のように、色は人を惹きつける。\n同時に、その過剰さがどこか不安を生む。\n\nふざけているように見えるのに、軽くならない。\n滑稽さの中に緊張感が残る。\nそこにHOMME PLUSらしい強度があります。",
      },
      {
        index: "04",
        title:
          "膨らんだパンツは、身体を道化師的な存在へ変える",
        text:
          "膨らんだパンツや丸みを帯びたシルエットは、このシーズンの重要な要素です。\nそれは単に面白い形ではありません。\n身体の重心を変え、歩き方や見え方に滑稽さを与えます。\n\nしかし、その滑稽さは弱さではありません。\nクラシックなジャケットやテーラードの中に、道化師の身体性が入り込むことで、男性服の緊張感がずらされる。\n\nHOMME PLUSは、男性服の威厳を壊すのではなく、その中に異なる身体感覚を差し込んでいます。",
      },
      {
        index: "05",
        title:
          "クラシックな服の中に、道化師の知性が入り込む",
        text:
          "COMME des GARÇONS HOMME PLUSは、長く男性服やテーラードの前提を問い直してきました。\n2023SSでも、クラシックな服の構造は完全には消えていません。\nジャケット、パンツ、シャツ、セットアップのような秩序が残っています。\n\nしかしそこに、色の切り替え、膨らみ、奇妙なバランス、道化師的な滑稽さが入り込む。\n\nつまり、クラシックな服が道化師に変装するのではありません。\nクラシックな服そのものの中に、道化師の批評性が入り込んでいる。\nここがこのシーズンの面白さです。",
      },
      {
        index: "06",
        title:
          "ジョーカーは、ルールの中にいる例外である",
        text:
          "トランプのジョーカーや現代的な道化師像には、宮廷道化師の記憶が残っています。\nジョーカーは、ゲームの中で例外的なカードです。\n決まった役割から少し外れ、場を乱し、ルールの中で異物として機能します。\n\n2023SSCOMME des GARCONS のHOMME PLUSも、その感覚に近い。\n服はクラシックなルールの中にありながら、色、形、身体感覚によって場を乱します。\n\nその“例外として残る力”が、このシーズンのパンク性です。",
      },
      {
        index: "07",
        title:
          "レンタルで分かるのは、写真では伝わらない身体の違和感",
        text:
          "COMME des GARCONS HOMME PLUSの服は、画像で見ると“派手な服”や“変わった服”として消費されがちです。\nしかし実際に着ると、パンツの膨らみ、色の切り替え、身体の重心、布の動き方が、写真とは違う感覚を作ります。\n\nEnclopediaがこのシーズンを記事化する意味は、単に知識を増やすためではありません。\n読むことで背景を知り、実際に着ることで身体感覚として理解する。\nその流れを作るためです。",
      },
      {
        index: "08",
        title:
          "買取で見るべきなのは、奇抜さではなく文脈",
        text:
          "コムデギャルソンオムプリュスの買取では、単に派手な服だから価値がある、という見方では不十分です。\nどのシーズンか。どのテーマか。どのルックに近いか。どれだけHOMME PLUSらしい男性服への問いが表れているか。\n\n2023SS『ANOTHER KIND OF PUNK』のようなテーマ性の強いシーズンは、まさに文脈が価値になる代表例です。\nEnclopediaでは、HOMME PLUSの服を単なる古着としてではなく、ブランドの思想やコレクション背景まで含めて確認します。",
      },
    ],
    quote:
      "ANOTHER KIND OF PUNKは、破れた服の話ではない。権威のすぐそばで、笑いながら批評を差し込む態度の話です。",
    perspectiveTitle:
      "Enclopediaは、COMME des GARCONS HOMME PLUSを“見る服”ではなく“着て理解するアーカイブ”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "2023SS『ANOTHER KIND OF PUNK』を、宮廷道化師、ジョーカー、権威への批評、パンクの態度、川久保玲の男性服観から読み解きます。",
      },
      {
        number: "02",
        title: "RENTAL EXPERIENCE",
        text:
          "COMME des GARCONS HOMME PLUSのシーズン性は、実際に着ることで理解が深まります。色、膨らみ、重心、違和感をレンタルで体験できる導線へつなげます。",
      },
      {
        number: "03",
        title: "BUYBACK / ARCHIVE VALUE",
        text:
          "COMME des GARÇONS HOMME PLUSの買取、コムデギャルソン全般の買取、HOMME PLUSブランドページへ内部リンクをつなぎ、検索流入から実際の利用・相談へ接続します。",
      },
    ],
    experienceTitle:
      "ANOTHER KIND OF PUNKは、読むだけではなく、着ることで態度が分かる。",
    experienceBody:
      "画面上では、強い色や道化師的なシルエットが先に目に入ります。\nしかし実際に身体へ乗せると、パンツの膨らみ、重心の変化、左右で切り替えられた色の違和感、クラシックな服の中に入り込んだ滑稽さが、よりはっきりと理解できます。\n\nEnclopediaでは、アーカイブを所有物ではなく、考え方を身体で辿るメディアとして扱います。\nCOMME des GARÇONS HOMME PLUS 2023SSは、その体験と非常に相性の良いシーズンです。",
    experienceItems: [
      "膨らんだパンツの重心を身体で知る",
      "左右非対称の配色が作る違和感を体感する",
      "クラシックな服に入り込む道化師的な滑稽さを読む",
      "背景を読んだ後にHOMME PLUSのレンタルで確かめる",
    ],
    archiveItemsTitle:
      "ANOTHER KIND OF PUNKを入口に、COMME des GARCONS HOMME PLUSをレンタルで体験する。",
    archiveItemsBody:
      "在庫導線には、COMME des GARCONS HOMME PLUSのシーズン性と接続できる視点を添えます。単なる商品一覧ではなく、コレクション理解の続きを設計します。",
    archiveItems: [
      {
        label: "RENTAL FOCUS 01",
        title: "レンタルできるCOMME des GARÇONS HOMME PLUSを見る",
        productPath:
          "/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
        productImage: "",
        text:
          "HOMME PLUSのシーズン性やシルエットは、実際に着ることで理解が深まります。Enclopediaでオムプリュスのアーカイブを体験できます。",
      },
      {
        label: "BUYBACK FOCUS 03",
        title: "COMME des GARCONS HOMME PLUS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons-homme-plus",
        productImage: "",
        text:
          "HOMME PLUSのジャケット、パンツ、シャツ、シーズンテーマの強いアーカイブまで。オムプリュスの買取対象と査定視点を確認できます。",
      },
    ],
    finalCta: {
      title:
        "ANOTHER KIND OF PUNKを読んだら、次はCOMME des GARCONS HOMME PLUSを着て確かめる。",
      body:
        "COMME des GARÇONS HOMME PLUS 2023SSは、パンクを見た目の記号ではなく、権威に対する態度として捉え直したシーズンです。\nEnclopediaでは、HOMME PLUSのアーカイブを読むだけでなく、実際にレンタルして体験できます。\n気になる一着がある方、またはHOMME PLUSの買取を相談したい方は、商品一覧またはLINEからご確認ください。",
      buttonLabel: "レンタルできるCOMME des GARCONS HOMME PLUSを見る",
      buttonHref:
        "/search/COMME%20DES%20GARCONS%20HOMME%20PLUS/",
    },
  };
  
  export default collection;